import { registerLocaleData } from '@angular/common';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import localeFr from '@angular/common/locales/fr';
import { ApplicationConfig, LOCALE_ID, provideZoneChangeDetection } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { provideAnimations } from '@angular/platform-browser/animations';
import { provideRouter } from '@angular/router';
import { provideTaiga } from '@taiga-ui/core';

import { importProvidersFrom, signal } from '@angular/core';
import { ServiceWorkerModule } from '@angular/service-worker';
import { TUI_FRENCH_LANGUAGE, TUI_LANGUAGE } from '@taiga-ui/i18n';
import { routes } from './app.routes';
import { TestResolver } from './components/test-data-grid/resolvers/test.resolver';
import { loadingInterceptor } from './core/interceptors/loading';
registerLocaleData(localeFr);

export const appConfig: ApplicationConfig = {
  providers: [
    provideAnimations(),
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(routes),
    provideHttpClient(withInterceptors([loadingInterceptor])),
    Title,
    { provide: LOCALE_ID, useValue: 'fr-FR' },
    importProvidersFrom(
      ServiceWorkerModule.register('ngsw-worker.js', {
        enabled: true,
        registrationStrategy: 'registerWhenStable:30000',
      }),
    ),
    provideTaiga(),
    {
      provide: TUI_LANGUAGE,
      useValue: signal(TUI_FRENCH_LANGUAGE),
    },
    TestResolver,
  ],
};
